import { UiElement } from "../../ui/UiElement.js";
import "./PopupHeader.css";

/**
 * Pagination helper class for paging of popup metadata
 */
export class PopupHeader extends UiElement {

    class_ = ["popup-header"];
    html_ = `
        <div class="popup-header-inner">
            <div class="popup-header-item popup-header-label"></div>
            <div class="popup-header-item popup-header-title"></div>
            <div class="popup-header-dropdown"></div>
        </div>
    `;

    itemTemplate_ = `
        <div class="popup-item-title"></div>
        <div class="popup-item-counter"></div>
    `;

    layers = {};
    index = 0;

    constructor(target) {

        super(target, {
            "show_index": []
        });

        this.setHtml(this.html_);
        this.setClass(this.class_);
    }

    reset() {
        this.off("show_index");
        this.getElement().classList.remove("dropdown-enabled");
        this.query(".popup-header-dropdown").innerHTML = "";
        this.query(".popup-header-label").innerHTML = "";
        this.query(".popup-header-title").innerHTML = "";
        this.index = 0;
        this.layerCount = 0;
        this.layers = {};
    }

    addLayer(layer) {
        const index = this.index++;

        if (layer.uniqueId in this.layers) {
            ++this.layers[layer.uniqueId].counter;
            return;
        }

        this.layers[layer.uniqueId] = {
            layer: layer,
            startIndex: index,
            counter: 1
        };
    }

    setLayer(layer, title) {
        const items = this.queryAll(".popup-header-dropdown .popup-item");
        for (let i = 0; i < items.length; ++i) {
            items[i].style.display = (items[i].dataset.id == layer.uniqueId) ? "none" : "flex";
        }

        const headerLabel = this.query(".popup-header-label");
        const options = {
            title: title || layer.title,
            counter: this.layers[layer.uniqueId].counter,
            chevron: true
        };
        this.setItemContent_(headerLabel, options);

        const headerTitle = this.query(".popup-header-title");
        options.title = layer.title;
        this.setItemContent_(headerTitle, options);
    }

    initDropdown() {
        if (Object.keys(this.layers).length == 1) return;
        this.getElement().classList.add("dropdown-enabled");

        const dropdown = this.query(".popup-header-dropdown");
        for (let key in this.layers) {
            const dropdownItem = document.createElement("div");
            dropdownItem.classList.add("popup-item");
            dropdownItem.dataset.id = key;
            dropdownItem.style.display = "none";

            this.setItemContent_(dropdownItem, {
                title: this.layers[key].layer.title,
                counter: this.layers[key].counter
            });

            dropdownItem.addEventListener("click", e => {
                this.fire("show_index", this.layers[key].startIndex);
            })

            dropdown.appendChild(dropdownItem);
        }
    }

    setItemContent_(element, options) {
        element.innerHTML = this.itemTemplate_;
        element.title = options.title;
        element.querySelector(".popup-item-title").innerText = options.title;
        element.querySelector(".popup-item-counter").innerText = options.counter;
        if(options.chevron) element.insertAdjacentHTML("beforeend", '<div class="popup-item-chevron"><i class="fas fa-chevron-down"></i></div>')
    }

}